module.exports = __webpack_public_path__ + "img/illus_tutorial_3@2x.38be0dcf.png";